export default "__VITE_ASSET__Chq$maQ8__"